// import React from "react";
// import Breadcrumbs from "../../CommonElements/Breadcrumbs";
// import DefaultContain from "../../Component/Dashboard";
import BajoContain from "../../Component/Bajo/containers/BajoContain";
import PageContainer from "../../Layout/Containers/PageContainer";
// import CabilContain from "../../Component/Cabil";

const Bajo = () => {
  return (
    <PageContainer
    >
      <BajoContain />
    </PageContainer>
  );
};

export default Bajo;
